import { useMemo } from "react";

export const useSpellCheckerViewModel = ({
  name,
  text,
  onTextChange,
  spellCheckerProps
}) => {
  const words = useMemo(() => {
    const errors = spellCheckerProps.errors;

    const result = [];

    for (let i = 0; i < errors.length; i++) {
      const error = errors[i];

      if (result.length === 0) {
        result.push(text.slice(0, error.pos));
      } else {
        result.push(text.slice(result.join().length - 1, error.pos));
      }

      result.push(text.slice(error.pos, error.pos + error.len));

      if (errors.length - 1 === i) {
        result.push(text.slice(error.pos + error.len));
      }
    }

    return result.filter(word => word !== "");
  }, [spellCheckerProps.errors, text]);

  const shouldDisplayErrors =
    spellCheckerProps.errors.reduce((prev, next) => {
      if (text.includes(next.word)) {
        prev.push(true);
      }

      return prev;
    }, []).length !== 0;

  const getWordError = (spellErrors, word) =>
    spellErrors.find(error => error.word === word);

  const handleWordReplace = (incorrectWord, word) => {
    const value = text.replace(incorrectWord, word);

    onTextChange(undefined, {
      name,
      value
    });
    spellCheckerProps.check([
      {
        name,
        value
      }
    ]);
  };

  const handleIgnoreClick = word => () =>
    spellCheckerProps.ignoreWord(name, word);

  return {
    words,
    shouldDisplayErrors,
    getWordError,
    handleWordReplace,
    handleIgnoreClick
  };
};
